import fetch from "../utils/fetch";

//创建人员
export const fetchAddEmployee = body =>
  fetch(`employees`, {
    method: "post",
    body
  });

//员工列表
export const fetchEmployeeList = ({
  name = "",
  mobilePhone = "",
  type = "",
  pageNum,
  pageSize
}) =>
  fetch(
    `employees/list?name=${name}&mobilePhone=${mobilePhone}&type=${type}&pageNum=${pageNum}&pageSize=${pageSize}`
  );

//修改员工信息
export const fetchEditEmployee = body =>
  fetch("employees", {
    method: "put",
    body
  });

//删除员工
export const fetchDeleteEmployee = ({ employeesId }) =>
  fetch(`employees/${employeesId}`, {
    method: "delete"
  });
